import { darken, lighten, makeStyles } from '@material-ui/core'

import { getFont, lang } from '../../../../localization'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '4fr 4fr 3fr',
    backgroundColor: theme.palette.background.default,
    padding: '14px 8px'
  },
  metadataContainer: {
    width: '100%',
    display: 'flex',
    padding: '14px 24px',
    backgroundColor: theme.palette.grey[200]
  },
  metadatakey: {
    marginRight: 20
  },
  metadataButton: {
    display: 'flex',
    alignItems: 'center'
  },
  paper: {
    borderRadius: 8,
    marginBottom: 12,
    boxShadow:
      '0px 1px 1px -1px rgb(0 0 0 / 16%), 0px 1px 1px 0px rgb(0 0 0 / 8%), 0px 1px 1px 0px rgb(0 0 0 / 8%)'
  },
  roomTypeRow: {
    display: 'grid',
    gridTemplateColumns: '4.121fr 1.299fr repeat(14,1fr)',
    height: 67,
    alignItems: 'center',
    backgroundColor: theme.palette.grey[300]
  },
  roomTypeRowForMonth: {
    gridTemplateColumns: '7fr 2fr repeat(31,1fr)'
  },
  ratePlanRow: {
    display: 'grid',
    gridTemplateColumns: '4.121fr 1.299fr repeat(14,1fr)',
    height: 67,
    alignItems: 'center',
    borderTop: '1px solid #e7e7e7',
    backgroundColor: theme.palette.grey[100]
  },
  ratePlanRowForMonth: {
    gridTemplateColumns: '7fr 2fr repeat(31,1fr)'
  },
  channelRow: {
    backgroundColor:
      theme.palette.type === 'light'
        ? lighten(theme.palette.secondary.light, 0.8)
        : darken(theme.palette.secondary.light, 0.8),
    display: 'grid',
    gridTemplateColumns: '4.121fr 1.299fr repeat(14,1fr)',
    height: 67,
    alignItems: 'center',
    borderTop: '1px solid #e7e7e7'
  },
  channelRowRowForMonth: {
    gridTemplateColumns: '7fr 2fr repeat(31,1fr)'
  },
  dayContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: 'gray',
    'box-sizing': 'border-box',
    height: '100%',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`,
    '& input': {
      fontSize: 12,
      width: '98%',
      textAlign: 'center',
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      color: theme.palette.type === 'dark' ? 'white' : 'black',
      fontFamily: getFont()
    }
  },
  priceDayContianer: {
    '& input': {
      fontSize: 10
    }
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2'
  },
  selectedDayContainer: {
    border: `2px solid ${theme.palette.grey[700]}`,
    borderRadius: 4
  },
  rowName: {
    marginLeft: 15,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 15
  },
  rowNameTitle: {
    flex: 1,
    marginLeft: 10,
    fontSize: 12
  },
  channelName: {
    marginLeft: 28,
    '& h5': {
      color: theme.palette.secondary.dark,
      fontSize: 12,
      fontFamily: 'IranSans'
    }
  },
  rowNameContainer: {
    display: 'flex',
    alignItems: 'center'
    // marginLeft: '3%'
  },
  channel: {
    marginLeft: 8,
    cursor: 'pointer'
  },
  buttonsContainer: {
    // width: 30
    display: 'flex',
    flexDirection: 'column'
  },
  roomIcon: {
    width: 30
  },
  channelArrowRight: {
    marginRight: 6,
    fontSize: 14,
    transition: `transform 0.2s`,
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`,
    cursor: 'pointer'
  },
  channelArrowRightCollapsed: {
    transform: `rotate(${lang === 'fa' ? '-90deg' : '90deg'})`
  },
  copyButtonContainer: {
    marginRight: 8
  },
  copyButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    transition: 'all 0.5s linear',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  },
  numberOfRatePlans: {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },
  ratePlansLoading: {
    width: 14,
    marginRight: 6,
    marginLeft: 4,
    marginTop: 4
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  resetButton: {
    backgroundColor: theme.palette.grey[700],
    color: theme.palette.primary.contrastText
  },
  numberOfRooms: {
    position: 'absolute',
    zIndex: 1000,
    right: 8,
    bottom: 16,
    fontSize: 12
  },
  skeleton: { width: '70%' }
}))

export default useStyles
